import { Injectable } from '@angular/core';
import {
    Router,
    CanActivate,
    ActivatedRoute,
    ActivatedRouteSnapshot,
} from '@angular/router';
import { AuthService } from 'src/app/modules/auth/auth.service';
import { Observable } from 'rxjs';

@Injectable()
export class AuthGuardService implements CanActivate {
    constructor(private router: Router, private auth: AuthService) {}
    canActivate(route: ActivatedRouteSnapshot): Observable<boolean> | boolean {
        const tokenRoute = !!(
            route.url.find((url) => url.path.includes('change-password')) &&
            route.queryParamMap.get('token')
        );
        if (!(this.auth.isAuthenticated() || tokenRoute)) {
            this.router.navigate(['/auth/login']);
            return false;
        }
        return true;
    }
}
